// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ov5b","left":"styles_left__2gprY"};